import request from './cache/requestCache';
import proxy from './requestProxy';

export function getOneIdApiKey(oneIdClientUrl) {   
    const url = `${oneIdClientUrl}/api-key`;
    return request.post(url)
        .use(proxy)
        .then(res => {
            let oneIdApiKey;
            if (res.status === 200) {
                const { body : {error}, headers = {} } = res;
                /**
                 * if getApiKey successfully, oneId api return body as follow
                 *  {
                        "data": null,
                        "error": null
                    }
                 */
                if (error === null && headers["api-key"] !==  null && headers["api-key"] !== undefined) {
                    oneIdApiKey = headers["api-key"];
                }
            }
            return oneIdApiKey
        }).catch((err) => {
            return undefined;
        });
}

// oneId getGuess info doesn't return email for privacy reason, so we need to retrieve it for optIns update
export function getOneIdEmail(oneIdClientUrl, swid, accessToken) {
    const url = `${oneIdClientUrl}/guest/${swid}`;
    return request(url)
        .set('Authorization', `BEARER ${accessToken}`)
        .set('Accept', 'application/json')
        .use(proxy)
        .then(res => {
            if (res && res.status === 200) {
                const { body: {data: {profile: {email} = {}} = {}} = {}} = res;               
                if (email) {
                    return {
                        email,
                        isSuccess: true,
                    }
                }
            }
            return { isSuccess: false }
        }).catch((err) => {
            return { isSuccess: false };
        });
}

export async function updateOneIdMarkettingOptIn(oneIdClientUrl, oneIdApiKey, email) {      
    const url = `${oneIdClientUrl}/marketing/options`;
    const payload = {
        "email": email,
        "source": "ESPN watch web opt-in",
        "options": {
            "ESPN+_L": true
        },
        "textIDsMap": {
            "ESPN+_L": ""
        }
    }
    return request.post(url)
        .send(payload)
        .set('Authorization', `APIKEY ${oneIdApiKey}`)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .use(proxy)
        .then(res => {
            const { body: {error} = {}, status } = res || {};
            if (status === 200) {
                
                if (error === null) {
                    return {isSuccess: true, err: null};
                }
            }
            return {
                isSuccess: false,
                err: `status code: ${res.status} errMsg: ${error}`
            }
        })
        .catch((err) => {
            return {
                "isSuccess": false,
                err: "updateOneIdMarkettingOptIn failed on catch"
            }
        });
}




// WEBPACK FOOTER //
// ./app/lib/api/oneIdApi.js